import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import InboxManagerMixin from '@/helpers/vue_mixins/v3/copilot_inbox_manager/InboxManagerMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import FetchFacebookPosts from '@/plugins/graphql/queries/v3/fetch-facebook-posts.gql';
import InboxFbPost from '@/plugins/graphql/subscriptions/v3/inbox-fb-post.gql';
import InboxConversation from '@/components/v3/inbox_manager/InboxConversation.vue';
import BaseInnerLoader from '@/components/v2/BaseInnerLoader';
let FacebookComments = class FacebookComments extends Mixins(PaginatorMixin, InboxManagerMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.fbPosts = [];
        this.expandedPosts = {};
        this.isFetchMore = false;
        this.expandedMessages = {};
        this.subscription = null;
    }
    initiateSubscription() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subscription = this.$apollo
            .subscribe({
            query: InboxFbPost,
            variables: {
                pageRecipientGlobalId: this.$store.state.selectedRecipient.baseUuid,
                prGlobalId: this.$store.state.selectedRecipient.baseUuid,
            },
        })
            .subscribe({
            next: ({ data }) => {
                const { fbPost } = data.inboxFbPost;
                this.mapNewFbPost(fbPost);
            },
            error(err) {
                console.error('Subscription error:', err);
            },
        });
    }
    toggleExpand(index) {
        this.$set(this.expandedMessages, index, !this.expandedMessages[index]);
    }
    mapNewFbPost(newInboxFbPost) {
        let isExisting = false;
        const updatedInboxFbPosts = this.fbPosts.filter((inboxFbPost) => {
            if (inboxFbPost.baseGlobalId === newInboxFbPost.baseGlobalId) {
                isExisting = true;
                return false;
            }
            return true;
        });
        this.fbPosts = [...updatedInboxFbPosts, newInboxFbPost];
    }
    onSelectedRecipient() {
        this.expandedPosts = {};
        this.$store.commit('setSelectedFbpost', {});
        this.initiateSubscription();
    }
    displayPagePhoto(post) {
        if (post.page.photo) {
            const { originalUrl } = post.page.photo?.blob;
            return originalUrl;
        }
        return this.defaultPhoto;
    }
    postClicked(post, event) {
        this.shouldScrollToBottom = false;
        if ([
            '#expanded-section',
            '.post-time',
            '.name',
            '.fbpost-name-and-badge',
            '.image-card',
            '.image',
        ].some((className) => event.target.matches(className))) {
            this.$store.commit('setSelectedFbpost', {});
            // Check if the clicked post is already expanded
            if (this.expandedPosts[post.baseGlobalId]) {
                // Close the clicked post if it is already expanded
                this.$set(this.expandedPosts, post.baseGlobalId, !this.expandedPosts[post.baseGlobalId]);
            }
            else {
                this.expandedPosts = Object.keys(this.expandedPosts).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {});
                // Toggle the expanded state of the clicked post if it is not expanded
                this.$set(this.expandedPosts, post.baseGlobalId, !this.expandedPosts[post.baseGlobalId]);
            }
        }
    }
    displayMessageImage(post) {
        if (!post || !post.photo) {
            return this.defaultPhoto;
        }
        const { originalUrl } = post.photo.blob;
        if (originalUrl) {
            return originalUrl;
        }
        return this.defaultPhoto;
    }
    FetchFacebookPosts() {
        this.shouldScrollToBottom = false;
        if (this.isFetchMore) {
            return; // Do not fetch more if already in progress
        }
        const { endCursor, hasNextPage } = this.pageInfo;
        if (hasNextPage) {
            this.isFetchMore = true; // Set flag to indicate fetch in progress
            this.$apollo
                .query({
                query: FetchFacebookPosts,
                variables: {
                    pageRecipientUuid: this.selectedRecipient.uuid,
                    prGlobalId: this.selectedRecipient.baseUuid,
                    first: 5,
                    after: endCursor,
                },
            })
                .then(({ data }) => {
                this.pageInfo = data.fetchFacebookPosts.pageInfo;
                const moreNodes = data.fetchFacebookPosts.edges.map((edge) => edge.node);
                const sortNodes = moreNodes.slice().reverse();
                this.fbPosts = [...sortNodes, ...this.fbPosts];
                const container = this.$refs.messageContent;
                const originalScrollTop = container.scrollTop;
                this.$refs.messageContent.scrollTop =
                    originalScrollTop + sortNodes.length * this.getItemHeight();
                this.isFetchMore = false;
            })
                .catch((err) => {
                console.log(err);
                this.isFetchMore = false;
            });
        }
        else {
            this.isFetchMore = false;
        }
    }
    handleScroll(event) {
        const list = event.target;
        const { scrollTop } = list;
        if (scrollTop <= 0) {
            // loadmore
            this.FetchFacebookPosts();
        }
    }
    mounted() {
        this.scrollToBottom();
        this.displayRecipientPhoto();
    }
    updated() {
        this.scrollToBottom();
    }
};
__decorate([
    Watch('selectedRecipient')
], FacebookComments.prototype, "onSelectedRecipient", null);
FacebookComments = __decorate([
    Component({
        components: {
            InboxConversation,
            BaseInnerLoader,
        },
        apollo: {
            fbPosts: {
                query: FetchFacebookPosts,
                variables() {
                    return {
                        pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                        first: 7,
                        after: this.startCursor,
                        prGlobalId: this.$store.state.selectedRecipient.baseUuid,
                    };
                },
                skip() {
                    return !this.$store.state.selectedRecipient.uuid;
                },
                update({ fetchFacebookPosts }) {
                    if (fetchFacebookPosts) {
                        const fbPosts = fetchFacebookPosts.edges.map((edge) => edge.node);
                        this.nodes = [...fbPosts].reverse();
                        this.pageInfo = fetchFacebookPosts.pageInfo;
                        this.shouldScrollToBottom = true;
                        return this.nodes;
                    }
                },
                subscribeToMore: {
                    document: InboxFbPost,
                    variables() {
                        return {
                            pageRecipientGlobalId: this.$store.state.selectedRecipient.baseUuid,
                            prGlobalId: this.$store.state.selectedRecipient.baseUuid,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        const { fbPost } = subscriptionData.data.inboxFbPost;
                        this.mapNewFbPost(fbPost);
                        return subscriptionData.data.inboxFbPost.fbPost;
                    },
                },
            },
        },
    })
], FacebookComments);
export default FacebookComments;
